import { getSapMaterial } from "@/modules/solrsearch";
import Handsontable from "handsontable";

const regex = /^\s*$/;

const state = {
  columnMaterial: null,
  columnQuantity: null,
  invalidCount: 0,
  loadingCount: 0,
  numberOfColumns: 8,
  tableData: null,
  tableItems: []
};

const getters = {
  getTableData(state) {
    return state.tableData && state.tableData.length > 0
      ? state.tableData
      : Handsontable.helper.createEmptySpreadsheetData(
          1,
          state.numberOfColumns
        );
  },
  getTableItems(state) {
    return state.tableItems && Array.isArray(state.tableItems)
      ? state.tableItems.map((item, index) => {
          item.id = index;
          return item;
        })
      : [];
  }
};

const actions = {
  changeTableData({ commit }, tableData) {
    //remove empty rows from tableData
    //the copy also avoids errors in vuex strict mode
    const filteredTableData = tableData.filter(row => {
      let str = row.join("");
      return str && str.length !== 0 && !regex.test(str);
    });
    commit("setTableData", filteredTableData);
  },

  tableDataToItems({ commit, state }) {
    commit("resetItems");

    let position = 0;

    state.tableData.forEach(row => {
      let materialNo = row[state.columnMaterial - 1].trim();
      let quantity = parseInt(row[state.columnQuantity - 1], 10);

      if (materialNo && quantity) {
        position += 1;
        let item = {
          description: "",
          materialNo: materialNo,
          position: position,
          quantity: quantity,
          validationStatus: 0
        };
        commit("pushItem", item);
      }
    });
  },

  async validateItem({ commit, rootState }, { item, index }) {
    commit("incrementLoading");
    commit("setItemValidationStatus", {
      index,
      validationStatus: 1
    });

    const divisions = rootState.customer.additionalDivisionForSearch
      ? [
          rootState.customer.division,
          rootState.customer.additionalDivisionForSearch
        ]
      : [rootState.customer.division];

    const { d: response } = await getSapMaterial(
      rootState.customer.salesOrganisation,
      rootState.customer.distributionChannel,
      divisions,
      rootState.customer.productHierarchies || [],
      item.materialNo
    );

    commit("decrementLoading");

    if (response.results && response.results.length) {
      commit("setItemValidationStatus", {
        index,
        validationStatus: 2
      });
      commit("setItemDescription", {
        category: response.results[0].item_category_group,
        description: response.results[0].material_description,
        index,
        materialNo: response.results[0].material_number
      });
    } else {
      commit("setItemValidationStatus", {
        index,
        validationStatus: -1
      });
      commit("incrementInvalid");
    }
  },

  removeTableItem({ commit }, item) {
    const index = item.id;
    if (item.validationStatus < 0) {
      commit("decrementInvalid");
    }
    commit("deleteTableItem", index);
  }
};

const mutations = {
  decrementInvalid(state) {
    state.invalidCount -= 1;
  },
  decrementLoading(state) {
    state.loadingCount -= 1;
  },
  deleteTableItem(state, index) {
    state.tableItems.splice(index, 1);
  },
  incrementInvalid(state) {
    state.invalidCount += 1;
  },
  incrementLoading(state) {
    state.loadingCount += 1;
  },
  pushItem(state, item) {
    state.tableItems.push(item);
  },
  resetItems(state) {
    state.tableItems = [];
    state.loadingCount = 0;
    state.invalidCount = 0;
  },
  setColumnMaterial(state, value) {
    state.columnMaterial = value;
  },
  setColumnQuantity(state, value) {
    state.columnQuantity = value;
  },
  setItemDescription(state, { index, materialNo, description, category }) {
    state.tableItems[index].materialNo = materialNo;
    state.tableItems[index].description = description;
    state.tableItems[index].category = category;
  },
  setItemValidationStatus(state, { index, validationStatus }) {
    state.tableItems[index].validationStatus = validationStatus;
  },
  setTableData(state, tableData) {
    state.tableData = tableData;
  },
  tableToBasketReset(state) {
    state.loadingCount = 0;
    state.invalidCount = 0;
    state.tableItems = [];
    state.tableData = null;
    state.columnMaterial = null;
    state.columnQuantity = null;
  }
};

export default {
  actions,
  getters,
  mutations,
  state
};
